var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "38px",
    viewBox: "0 0 38 38",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tw",
    transform: "translate(0.4179688 0.4176941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1694 36.3406C28.2041 36.3406 36.3388 28.2055 36.3388 18.1703C36.3388 8.13513 28.2041 0 18.1694 0C8.13472 0 0 8.13513 0 18.1703C0 28.2055 8.13472 36.3406 18.1694 36.3406Z",
    id: "Oval-3-Copy-15",
    fill: "#1DA1F2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4867 3.39628C15.4977 3.54532 15.4977 3.6944 15.4977 3.84345C15.4977 8.38956 11.9381 13.6277 5.4324 13.6277C3.4281 13.6277 1.5662 13.0634 0 12.084C0.284773 12.1159 0.558555 12.1266 0.854285 12.1266C2.50807 12.1266 4.03048 11.5836 5.2462 10.6573C3.69096 10.6254 2.38762 9.63525 1.93856 8.27246C2.15763 8.30438 2.37666 8.32568 2.60668 8.32568C2.92429 8.32568 3.24193 8.28308 3.53763 8.20859C1.91668 7.88916 0.700925 6.50511 0.700925 4.83358L0.700925 4.79101C1.17186 5.04653 1.71953 5.20623 2.29996 5.2275C1.3471 4.60998 0.722838 3.55597 0.722838 2.36354C0.722838 1.72475 0.898044 1.13918 1.20473 0.628138C2.94617 2.71488 5.56381 4.07764 8.49902 4.22671C8.44427 3.97119 8.4114 3.70505 8.4114 3.43888C8.4114 1.54375 9.98856 0 11.949 0C12.9676 0 13.8876 0.415219 14.5338 1.08596C15.3333 0.936914 16.1 0.649439 16.779 0.255522C16.5162 1.05404 15.9576 1.72478 15.2238 2.15062C15.9357 2.07613 16.6257 1.88445 17.2609 1.61831C16.7791 2.29966 16.1767 2.9065 15.4867 3.39628Z",
    transform: "translate(9.993176 11.81071)",
    id: "Shape",
    fill: "#FFFFFF",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwColor);
export default __webpack_public_path__ + "static/media/Tw_color.0abaa2c224682a5212abf9cf6f6af152.svg";
export { ForwardRef as ReactComponent };